import { PaymentMethod } from 'app/shared/model/enumerations/payment-method.model';
import { BillingPeriod } from 'app/shared/model/enumerations/billing-period.model';
import { Currency } from 'app/shared/model/enumerations/currency.model';

export interface IBankAccount {
  id?: number;
  bankAccountNumber?: string | null;
  bankAccountHolder?: string | null;
  paymentMethod?: keyof typeof PaymentMethod | null;
  billingPeriod?: keyof typeof BillingPeriod | null;
  currency?: keyof typeof Currency | null;
}

export const defaultValue: Readonly<IBankAccount> = {};
